var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { $$, $e } from './utils';
var MonthInput = /** @class */ (function () {
    function MonthInput(input) {
        this.input = input;
        var value = (this.value = toDate(input.getAttribute('value')));
        var min = (this.min = toDate(input.getAttribute('min')) || toDate('1900-01-01'));
        var max = (this.max = toDate(input.getAttribute('max')) || toDate('2999-12-31T23:59:59'));
        this.year = this.mkselect(yearOptions(min.getFullYear(), max.getFullYear(), value), '年', !!input.dataset.invert);
        this.month = this.mkselect(monthOptions(value), '月');
    }
    MonthInput.prototype.init = function () {
        var _this = this;
        var container = $e.apply(void 0, __spreadArray(['span', { className: 'datetime-container' }], this.mkelems(), false));
        this.input.type = 'hidden';
        this.input.after(container);
        container.addEventListener('change', function () { return _this.onChange(); });
        this.onChange();
    };
    MonthInput.prototype.mkselect = function (options, empty, invert) {
        var _a = this.input, className = _a.className, required = _a.required;
        return $e.apply(void 0, __spreadArray(['select',
            { className: "".concat(className, " datetime-select"), required: required },
            emptyOption(empty, this.value, required)], (invert ? options.reverse() : options), false));
    };
    MonthInput.prototype.mkelems = function () {
        return [this.year, this.month];
    };
    MonthInput.prototype.onChange = function () {
        var date = this.mkdate();
        this.input.value =
            date && !Number.isNaN(date.getTime()) && date >= this.min && date <= this.max ? this.mkvalue(date) : '';
        this.update();
        this.input.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
    };
    MonthInput.prototype.mkdate = function () {
        return mkdate(this.year.value, this.month.value);
    };
    MonthInput.prototype.mkvalue = function (date) {
        return datestr(date).slice(0, 7);
    };
    MonthInput.prototype.update = function () {
        var y = +this.year.value;
        var min = y === this.min.getFullYear() ? this.min.getMonth() + 1 : 1;
        var max = y === this.max.getFullYear() ? this.max.getMonth() + 1 : 12;
        updateSelect(this.month, min, max);
    };
    return MonthInput;
}());
var DateInput = /** @class */ (function (_super) {
    __extends(DateInput, _super);
    function DateInput(input) {
        var _this = _super.call(this, input) || this;
        _this.day = _this.mkselect(dayOptions(_this.value), '日');
        return _this;
    }
    DateInput.prototype.mkelems = function () {
        return __spreadArray(__spreadArray([], _super.prototype.mkelems.call(this), true), [this.day], false);
    };
    DateInput.prototype.mkdate = function () {
        return mkdate(this.year.value, this.month.value, this.day.value);
    };
    DateInput.prototype.mkvalue = function (date) {
        return datestr(date);
    };
    DateInput.prototype.update = function () {
        _super.prototype.update.call(this);
        var y = +this.year.value;
        var m = +this.month.value;
        var min = dateeq(this.min, y, m) ? this.min.getDate() : 1;
        var max = dateeq(this.max, y, m) ? this.max.getDate() : lastday(+this.year.value, +(this.month.value || 1));
        updateSelect(this.day, min, max);
    };
    return DateInput;
}(MonthInput));
var DateTimeInput = /** @class */ (function (_super) {
    __extends(DateTimeInput, _super);
    function DateTimeInput(input) {
        var _this = _super.call(this, input) || this;
        _this.time = _this.mkselect(timeOptions(+input.step || 60, _this.value, input.dataset.minTime || '00:00', input.dataset.maxTime || '23:59'), '時:分');
        return _this;
    }
    DateTimeInput.prototype.mkelems = function () {
        return __spreadArray(__spreadArray([], _super.prototype.mkelems.call(this), true), [this.time], false);
    };
    DateTimeInput.prototype.mkdate = function () {
        var _a = this.time.value.split(':'), h = _a[0], m = _a[1];
        return mkdate(this.year.value, this.month.value, this.day.value, h, m);
    };
    DateTimeInput.prototype.mkvalue = function (date) {
        return [datestr(date), timestr(date)].join('T');
    };
    DateTimeInput.prototype.update = function () {
        _super.prototype.update.call(this);
        var y = +this.year.value;
        var m = +this.month.value;
        var d = +this.day.value;
        var min = dateeq(this.min, y, m, d) ? timestr(this.min) : '00:00';
        var max = dateeq(this.max, y, m, d) ? timestr(this.max) : '23:59';
        updateSelect(this.time, min, max);
    };
    return DateTimeInput;
}(DateInput));
function toDate(datestr) {
    var match = datestr && /^(\d\d\d\d)-(\d\d)(?:-(\d\d)(?:T(\d\d):(\d\d)(?::\d\d)?)?)?$/.exec(datestr);
    if (!match)
        return;
    var date = mkdate(match[1], match[2], match[3], match[4], match[5]);
    if (date && !Number.isNaN(date.getTime()))
        return date;
}
function mkdate(year, month, day, hour, min) {
    if (year === '' || month === '' || day === '' || hour === '' || min === '')
        return;
    return new Date(+year, +(month || 1) - 1, +(day || 1), +(hour || 0), +(min || 0));
}
function datestr(date) {
    return [date.getFullYear(), "0".concat(date.getMonth() + 1).slice(-2), "0".concat(date.getDate()).slice(-2)].join('-');
}
function timestr(dateOrHour, min) {
    var isDate = dateOrHour instanceof Date;
    var h = isDate ? dateOrHour.getHours() : dateOrHour;
    var m = isDate ? dateOrHour.getMinutes() : min;
    return ["0".concat(h).slice(-2), "0".concat(m).slice(-2)].join(':');
}
function dateeq(date, year, month, day) {
    return date.getFullYear() === year && date.getMonth() + 1 === month && (day == null || date.getDate() == day);
}
function lastday(year, month) {
    return new Date(year, month, 0).getDate();
}
function range(s, e) {
    return Array.from({ length: e - s + 1 }, function (_, k) { return k + s; });
}
function yearOptions(min, max, date) {
    return range(min, max).map(function (y) { return $e('option', { value: "".concat(y), selected: (date === null || date === void 0 ? void 0 : date.getFullYear()) == y }, "".concat(y, "\u5E74")); });
}
function monthOptions(date) {
    return range(1, 12).map(function (m) { return $e('option', { value: "".concat(m), selected: (date === null || date === void 0 ? void 0 : date.getMonth()) == m - 1 }, "".concat(m, "\u6708")); });
}
function dayOptions(date) {
    return range(1, 31).map(function (d) { return $e('option', { value: "".concat(d), selected: (date === null || date === void 0 ? void 0 : date.getDate()) == d }, "".concat(d, "\u65E5")); });
}
function timeOptions(step, date, min, max) {
    var options = [];
    for (var t = 0; t < 86400; t += step) {
        var h = Math.floor(t / 3600);
        var m = Math.floor((t % 3600) / 60);
        var value = timestr(h, m);
        if (min <= value && value <= max) {
            var selected = (date === null || date === void 0 ? void 0 : date.getHours()) == h && (date === null || date === void 0 ? void 0 : date.getMinutes()) == m;
            options.push($e('option', { value: value, selected: selected }, value));
        }
    }
    return options;
}
function emptyOption(empty, date, required) {
    return $e('option', { value: '', disabled: required, selected: date == null }, empty);
}
function updateSelect(sel, min, max) {
    Array.from(sel.options).forEach(function (opt) {
        if (opt.value === '')
            return;
        opt.hidden = opt.value < min || opt.value > max;
    });
    if (sel.value === '')
        void 0;
    else if (sel.value < min)
        sel.value = "".concat(min);
    else if (sel.value > max)
        sel.value = "".concat(max);
}
var constructors = {
    month: MonthInput,
    date: DateInput,
    'datetime-local': DateTimeInput,
};
$$('input[type=date i],input[type="datetime-local" i],input[type=month i]').forEach(function (elem) {
    var input = elem;
    var type = elem.getAttribute('type');
    new constructors[type](input).init();
});
